import api from '../services/config/api';

export const archidevDemand = async (idDemand: string, isArchived: boolean) =>
  api.patch(`/solicitacao/update-archived/${idDemand}?archived=${isArchived}`);
